<template>
  <div ref="scroller" class="load-more" :style="scrollerStyle">
    <template v-if="showLoadingWhale">
      <animation-loading-whale
        :center="false"
        :loading="isLoading"
        class="whale-wrap"
      ></animation-loading-whale>
    </template>
    <slot name="before-list" />
    <div v-for="(item, index) in list" :key="index">
      <slot :item="item" :index="index" :list="list" />
    </div>
    <template v-if="!isLoading">
      <template v-if="hasMore">
        <slot name="loading" v-if="$slots.loading" />
        <AnimationLoadmore :circleFm="{ background: theme }" v-else />
      </template>
      <template v-else>
        <div v-if="list.length === 0">
          <slot name="none" v-if="$slots.none" />
          <div class="no-more" v-else>暂无数据</div>
        </div>
        <template v-else>
          <slot name="noMore" v-if="$slots.noMore" />
          <div class="no-more" v-else>已全部展示</div>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import AnimationLoadmore from './AnimationLoadmore'
import AnimationLoadingWhale from './AnimationLoadingWhale.vue'
import bridgeMixin from '../mixins/bridge'

// never used
// const isDOMElement = obj =>
//   !!(obj && typeof window !== 'undefined' && (obj === window || obj.nodeType))
export default {
  name: 'LoadMore',
  mixins: [bridgeMixin],
  components: {
    AnimationLoadmore,
    AnimationLoadingWhale
  },
  props: {
    // 离底部距离
    bottomSpace: {
      type: Number,
      default: 0
    },
    // 监听的参数，deep watch 变化会更新
    parmas: {
      type: [String, Number, Array, Object]
    },
    // 每次加载个数
    pageCount: {
      type: Number,
      default: 20
    },
    // 滚动主体
    scrollBody: {
      default() {
        return window
      }
    },
    immediateRender: {
      type: Boolean,
      default: true
    },
    enabled: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: '#ff745b'
    },
    showFirstConsultRedDot: {
      type: Boolean,
      default: false
    },

    /**
     * 用于上拉加载
     */
    pullup: {
      type: Boolean,
      default: false
    },

    /**
     * 最外层父级元素
     */
    parentWrap: {
      type: HTMLDivElement
    }
  },
  data() {
    return {
      // 当前页码
      page: 0,
      hasMore: true,
      // 列表 scope 给外部 item
      list: [],
      isLoading: false,
      showLoadingWhale: false,
      startY: 0,
      cacheOffsetY: 0,
      offsetY: 0,
      offset: 0,
      minY: 0, //滚动主体与页面顶部的距离
      wrapperHeight: 0,
      duration: 0,
      documentHeight: 0,
      scrollMinHeight: 0,
      pos: {}
    }
  },

  computed: {
    scroller() {
      return this.$refs.scroller
    },

    alowPull() {
      // 在微信及部分浏览器上拉会出现橡皮筋效果，因此暂时只在客户端应用上拉刷新
      return this.pullup && this.platform.isYixinliApp
    },

    scrollerStyle() {
      return this.alowPull
        ? {
            transform: `translate3d(0, ${this.offsetY}px, 0)`,
            'transition-duration': `${this.duration}ms`,
            'min-height': `${this.scrollMinHeight}px`,
            position: 'relative'
          }
        : {}
    }
  },

  created() {
    this.scroll = () => this._scroll.call(this)
    this.page++
    if (this.immediateRender) this._trigger()

    // deep watch
    this.parmas &&
      this.$watch(
        () => this.parmas,
        () => {
          this.refresh()
        },
        {
          deep: true
        }
      )
  },

  mounted() {
    if (this.alowPull) {
      this.$nextTick(() => {
        //父组件挂载后再获取高度
        const {
          height: wrapperHeight
        } = this.parentWrap.getBoundingClientRect()
        const { height: scrollHeight } = this.scroller.getBoundingClientRect()
        this.wrapperHeight = wrapperHeight
        this.documentHeight = window.innerHeight
        this.scrollMinHeight =
          this.documentHeight - this.scroller.getBoundingClientRect().top
        this.minY = wrapperHeight - scrollHeight
      })

      // props传入是否允许下拉刷新
      this.scroller.addEventListener('touchstart', this.refreshTouchStart)
      this.scroller.addEventListener('touchmove', this.refreshTouchMove)
      this.scroller.addEventListener('touchend', this.refreshTouchEnd)
      if (this.mixinIsApp) {
        //当前webView禁止客户端下拉
        this.getBridge().call('isPullRefreshEnable', { enable: 0 })
      }
    }
  },

  destoryed() {
    this.scrollBody.removeEventListener('scroll', this.scroll)
    if (this.alowPull) {
      this.scroller.removeEventListener('touchstart', this.refreshTouchStart)
      this.scroller.removeEventListener('touchmove', this.refreshTouchMove)
      this.scroller.removeEventListener('touchend', this.refreshTouchEnd)
      if (this.mixinIsApp) {
        this.getBridge().call('isPullRefreshEnable', { enable: 1 })
      }
    }
  },
  methods: {
    _scroll() {
      const scrollTop =
        this.scrollBody.scrollTop ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      const bodyH = this.scrollBody.scrollHeight || document.body.scrollHeight
      const winH = this.scrollBody.offsetHeight || window.screen.availHeight
      if (bodyH - scrollTop - winH <= this.bottomSpace) {
        this.page++
        this._trigger()
      }
    },
    _trigger() {
      return new Promise(reslove => {
        this.scrollBody.removeEventListener('scroll', this.scroll)
        this.$emit(
          'render',
          this.page,
          ({ data, hasMore = data.length >= this.pageCount }) => {
            this.list = [...this.list, ...data]
            this.scrollBody.addEventListener('scroll', this.scroll)
            this.hasMore = hasMore
            if (this.showFirstConsultRedDot) {
              for (let i = 0; i < this.list.length; i++) {
                let item = this.list[i]
                if (
                  item.process_status === 'waitAccept' ||
                  item.process_status === 'waitConsult'
                ) {
                  item.showFirstConsultRedDot = this.showFirstConsultRedDot
                  i = this.list.length
                }
              }
            }
            reslove(this.list)
          }
        )
      })
    },

    refresh(keepList) {
      if (!keepList) this.list = []
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      this.page = 1
      this.hasMore = true
      return this._trigger()
    },
    /* eslint-disable */

    refreshTouchStart(e) {
      this.duration = 0
      this.stop()
      // 是否为第一个触点，若是则需要重置 cacheOffsetY 值
      let isFirstTouch = true
      this.startY = e.changedTouches[0].clientY
      Array.from(e.touches).forEach(touch => {
        const id = touch.identifier
        if (!this.pos[id]) {
          //如果已存在id即不是第一个触点
          this.pos[id] = touch.clientY
          return
        }
        isFirstTouch = false
      })
      if (isFirstTouch) {
        this.cacheOffsetY = this.offsetY
      }
    },

    refreshTouchMove(e) {
      //        let offset = 0
      let diff = 0
      Array.from(e.touches).forEach(touch => {
        //          const id = touch.identifier
        diff = touch.clientY - this.startY
        // 安卓touch.identifier不是唯一key，导致向下滑动时offset可能出现负数，
        //          if (this.pos[id]) {
        //            offset += Math.round(touch.clientY - this.pos[id])
        //          }
      })

      //        offset = this.cacheOffsetY + offset
      //        this.offset = offset

      // 超出边界时增加阻尼效果
      if (
        diff > 0 &&
        this.scroller.getBoundingClientRect().top >= this.minY //初始状态是相等的
      ) {
        this.showLoadingWhale = true
        this.offsetY = this.damping(diff * 4, 300)
      }
    },

    refreshTouchEnd(e) {
      //触发事件的触摸点集合
      if (this.scroller.getBoundingClientRect().top < this.minY) return
      Array.from(e.changedTouches).forEach(touch => {
        const id = touch.identifier
        if (this.pos[id]) {
          this.cacheOffsetY += Math.round(touch.clientY - this.pos[id])
        }
      })
      // 当所有触点都离开屏幕
      if (!e.touches.length) {
        console.log('this.offsetY2', this.offsetY)
        //          let conditions = this.platform.isAndroid
        //            ? this.offsetY > 32
        //            : this.offset > 48
        let conditions = this.offsetY > 32

        if (conditions) {
          //回弹到48显示加载动画，48根据加载动画的高度取得
          this.offsetY = 48
          this.duration = 200
          this.isLoading = true
          this.refresh()
            .then(() => {
              this.cacheOffsetY = 0
              this.pos = {}
              this.resetPosition()
            })
            .catch(e => {
              console.log(e)
              this.resetPosition()
            })
        } else {
          this.resetPosition()
        }
      }
    },
    // 超出边界时重置位置
    resetPosition() {
      this.offsetY = 0
      this.duration = 500
      this.isLoading = false
      setTimeout(() => {
        this.showLoadingWhale = false
      }, 500)
    },

    stop() {
      // 获取当前 translate 的位置
      const matrix = window
        .getComputedStyle(this.scroller)
        .getPropertyValue('transform')
      this.offsetY = Math.round(+matrix.split(')')[0].split(', ')[5])
    },

    // 阻尼函数
    damping(x, max) {
      let y = Math.abs(x)
      y = (0.82231 * max) / (1 + 4338.47 / Math.pow(y, 1.14791))
      return Math.round(x < 0 ? -y : y)
    }
  },
  watch: {
    hasMore(val) {
      if (!val) {
        this.scrollBody.removeEventListener('scroll', this.scroll)
      }
    },
    enabled(val, oldVal) {
      if (val !== oldVal) {
        this.scrollBody[val ? 'addEventListener' : 'removeEventListener'](
          'scroll',
          this.scroll
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/sass/config';
@import '../assets/sass/function';
@import '../assets/sass/mixin';

.load-more {
  /*position: relative;*/
  min-height: 32px; // 取上拉加载动画的高度，不然动画显示不出来
  .whale-wrap {
    position: absolute;
    top: pxToRem(-101);
    left: 50%;
    transform: translateX(-50%);
  }
  .no-more {
    width: 100%;
    line-height: pxToRem(88);
    font-size: pxToRem(26);
    color: #999;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// LoadMore.vue?75dd6ca3